import get from 'lodash/get';

export default function greaterThan(value, { min = 0, locale = {}, data = null, minKeys = [] }) {
  if (value === undefined || value === null || value === '') {
    return false;
  }
  if (minKeys.length > 0 && data) {
    const errors = minKeys
      .map((key, idx) => {
        const minValue = get(data, key, 0);
        if (Number(value) < minValue) {
          return locale.greaterThan[idx] || `Must be greater than ${minValue}`;
        }
        return false;
      })
      .filter((item) => item);
    return !!errors.length && errors.join(' ');
  }

  if (Number(value) < min) {
    return locale.greaterThan || `Must be greater than ${min}`;
  }

  return false;
}
